export default "__VITE_ASSET__Cq$ErTOS__"